export default "__VITE_ASSET__0ed9f051__"